import React, { ReactNode } from 'react';
import { Statistic } from 'antd';
import { StatisticProps as StatisticCopyProps } from 'antd/lib/statistic/Statistic';

export type StatisticProps = StatisticCopyProps & {
  children?: ReactNode;
};

const ProStatistic: React.FC<StatisticProps> = (props) => {
  const { children, ...resProps } = props;

  return <Statistic {...resProps}>{children}</Statistic>;
};

export default ProStatistic;
